export const BUTTON_CONTENT = 'Sign In';
